<template>
  <div class="container">
    <div id="rp_container"></div>
  </div>
</template>

<script>
// eslint-disable-next-line no-undef
export default {
  name: "ReepayComponent",
  props: {
    sessionId: {
      type: String,
      required: true,
    },
    onSuccess: {
      type: Function,
      default: () => {},
    },
    onFailure: {
      type: Function,
      default: () => {},
    },
  },
  mounted() {
    this.initializeCheckout();
  },
  methods: {
    async initializeCheckout() {
      if (this.sessionId) {
        // eslint-disable-next-line no-undef
        try {
          const Reepay = await this.$loadReepay();
          const rp = new Reepay.WindowCheckout(this.sessionId, {
            html_element: "rp_container",
          });
          // eslint-disable-next-line no-undef
          rp.addEventHandler(Reepay.Event.Accept, (data) => {
            console.log("Success", data);
            if (this.onSuccess) {
              this.onSuccess(data);
            }
          });
          // eslint-disable-next-line no-undef
          rp.on("paymentSuccess", (data) => {
            console.log("Payment Success:", data);
            if (this.onSuccess) {
              this.onSuccess(data);
            }
          });

          rp.on("paymentFail", (data) => {
            console.log("Payment Failed:", data);
            if (this.onFailure) {
              this.onFailure(data);
            }
          });
        } catch (error) {
          console.error("Failed to load Reepay SDK", error);
        }
      }
    },
  },
};
</script>

<style scoped>
/* Container to center the div */
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Full viewport height */
}

/* Default styles for larger screens */
#rp_container {
  width: 80%;
  height: 80vh;
  max-width: 500px;
  max-height: 730px;
}

/* Styles for mobile devices */
@media (max-width: 600px) {
  #rp_container {
    width: 90%;
    height: 100vh; /* Full viewport height on mobile */
    max-width: none; /* Remove max-width */
    max-height: none; /* Remove max-height */
  }
}
</style>
